import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import styles from 'components/common/common.module.scss';

type Props = {
  value: string;
  isCurrent?: boolean;
};

export function StateCircleIcon({
  value,
  isCurrent = true,
}: Props) {
  return (
    <Box className={isCurrent ? styles.circleCurrent : styles.circleIdle}>
      <Typography className={styles.text}>{value}</Typography>
    </Box>
  );
}

export default StateCircleIcon;
